import { makeStyles } from '@material-ui/core'

export const useRopInfoStyles = makeStyles(theme => ({
  ropCardsWrapper: {
    border: '1px solid #EAECF0',
    padding: 16
  }
}))
